
import {Tooltip} from "../../../../default/global/js/tooltip";

export function initFixedContact() {
    const el = document.querySelector('.js-fixedContact');
    if (!el) return;

    const tooltip = new Tooltip(el, {
        html: true,
        placement: 'top',
        trigger: 'click',
        popperConfig: { placement: 'top-end', strategy: 'fixed', modifiers: [{ name: 'preventOverflow', options: { padding: 20 } }] },
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-inner"></div></div>',
    });

    // The bundled Tooltip's click trigger only toggles on the button itself;
    // it has no outside-click handling, so close it explicitly on any click
    // outside the button and the open panel.
    document.addEventListener('click', (event) => {
        if (el.contains(event.target) || (tooltip.tip && tooltip.tip.contains(event.target))) {
            return;
        }
        tooltip.hide();
    });
}
